import React from 'react';
import { Container } from 'reactstrap';

//redux
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import ReportList from './ReportList';

const Reports = () => {
	const breadcrumbLinks = [{ to: '#', label: 'Inicio' }];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Reportes' links={breadcrumbLinks} />
					<ReportList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Reports;